(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseTypeDeleteController',DiseaseTypeDeleteController);

    DiseaseTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'DiseaseType'];

    function DiseaseTypeDeleteController($uibModalInstance, entity, DiseaseType) {
        var vm = this;
        vm.diseaseType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            DiseaseType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
